function initAboutSection() {
  const section = document.querySelector('.section-about');
  if(!section) return;


  const aboutSlider = new Swiper('.about-slider', {
    slidesPerView: 1.2,
    breakpoints: {
      768: {
        slidesPerView: 2,
      },
      1024: {
        slidesPerView: 3
      }
    },
    navigation: {
      prevEl: '.about-slider__button.prev',
      nextEl: '.about-slider__button.next',
    },
    pagination: {
      el: '.about-slider__pagination',
      type: 'bullets',
      clickable: true
    }
  });
}

window.addEventListener('load', initAboutSection);